import styled from "styled-components";
import { theme } from "styles";

export const Card = styled("div")`
  position: relative;
  background-color: ${theme.card.backgroundColor};
  box-shadow: 0 2px 4px ${theme.card.shadowColor};
  border-radius: 5px;
`;
